import { toastr } from 'react-redux-toastr';
import { ITINERARY_CLOSURE_REASON_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_ITINERARY_CLOSURE_REASONS,
  CLEAR_ITINERARY_CLOSURE_TOTAL_SALE_PRICE,
  FLAG_GETTING_ITINERARY_CLOSURE_REASONS,
  FLAG_ITINERARY_CLOSURE_REASON_ACTIVITY,
  GET_ITINERARY_CLOSURE_REASONS,
  GET_TOTAL_SALE_PRICE_FOR_ITINERARY_CLOSURE,
} from '../types';

const flagGettingItineraryClosureReasons = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_ITINERARY_CLOSURE_REASONS,
    payload: flag,
  });

const getItineraryClosureReasons = async () => async (dispatch) => {
  try {
    dispatch(flagGettingItineraryClosureReasons(true));
    const url = ITINERARY_CLOSURE_REASON_ENDPOINT;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const closureReasons = await response.json();
    dispatch({
      type: GET_ITINERARY_CLOSURE_REASONS,
      payload: closureReasons,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingItineraryClosureReasons(false));
  }
};

const clearItineraryClosureReasons = () => (dispatch) =>
  dispatch({
    type: CLEAR_ITINERARY_CLOSURE_REASONS,
  });

const flagItineraryClosureReasonActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_ITINERARY_CLOSURE_REASON_ACTIVITY,
    payload: flag,
  });

const getTotalSalePriceForItineraryClosure =
  ({ itineraryId }) =>
  async (dispatch) => {
    try {
      dispatch(flagItineraryClosureReasonActivity(true));

      const url = `${ITINERARY_CLOSURE_REASON_ENDPOINT}/total-sale/${itineraryId}`;
      const response = await fetch(url, DEFAULT_GET_CONFIG);

      await isErrorResponse(response, null, dispatch);

      const totalSalePrice = await response.json();

      dispatch({
        type: GET_TOTAL_SALE_PRICE_FOR_ITINERARY_CLOSURE,
        payload: totalSalePrice,
      });

      return totalSalePrice;
    } catch (error) {
      toastr.error('Error', error.message);

      dispatch({
        type: GET_TOTAL_SALE_PRICE_FOR_ITINERARY_CLOSURE,
        payload: 0,
      });

      return 0;
    } finally {
      dispatch(flagItineraryClosureReasonActivity(false));
    }
  };

const clearTotalSalePriceForItineraryClosure = () => (dispatch) =>
  dispatch({
    type: CLEAR_ITINERARY_CLOSURE_TOTAL_SALE_PRICE,
  });

export {
  flagGettingItineraryClosureReasons,
  getItineraryClosureReasons,
  clearItineraryClosureReasons,
  getTotalSalePriceForItineraryClosure,
  clearTotalSalePriceForItineraryClosure,
};
